import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    VStack,
    HStack,
    Text,
} from '@chakra-ui/react';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import Button from 'components/v4/Button';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import Image from 'components/v4/Image';

const OperatorPlatformIconLargeURL = ({
    darkMode,
    errors,
    touched,
    uploadHandler,
    logoFileRef,
    logoFileType,
    fileReaderResult,
    logoRef,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.name && touched.name}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Platform Icon (Large)
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Accepted formats: PNG, SVG
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <VStack width="100%" alignItems="normal">
                        <HStack>
                            <Box
                                border="1px solid"
                                borderColor="gray.200"
                                borderRadius="md"
                                p={6}
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                maxH="50px"
                                maxW="100%"
                                marginTop="15px">
                                {logoFileType === 'png' && (
                                    <Image
                                        ref={logoRef}
                                        src={fileReaderResult}
                                        maxH="50px"
                                        maxW="100%"
                                    />
                                )}
                                {logoFileType === 'svg' && (
                                    <object
                                        data={fileReaderResult}
                                        type="image/svg+xml"
                                        style={{
                                            maxHeight: '50px',
                                            maxWidth: '100%',
                                        }}></object>
                                )}
                            </Box>
                            <Box sx={{ paddingTop: '15px' }}>
                                <Button
                                    as="label"
                                    htmlFor="iconLargeURL-file-input"
                                    size="sm"
                                    cursor="pointer"
                                    height="30px"
                                    m={0}>
                                    Choose File
                                </Button>
                                <input
                                    id="iconLargeURL-file-input"
                                    style={{ display: 'none' }}
                                    type="file"
                                    accept=".svg,.png"
                                    onChange={uploadHandler}
                                    ref={logoFileRef}
                                />
                                {isHovered && (
                                    <FieldToolTip
                                        label="Enter large icon URL"
                                        ariaLabel="operator-platform-iconLargeURL-tip"
                                        left="25px"
                                    />
                                )}
                            </Box>
                        </HStack>
                    </VStack>
                </Box>
            </Stack>
        </FormControl>
    );
};

export default OperatorPlatformIconLargeURL;
